export enum PlannedActivitySignOffPeriodStatus {
  AdminSigned = 1,
  Completed = 2,
  Rejected = 3,
  NotSigned = 4,
  Reopened = 5,
  Outdated = 6,
  Closed = 7,
}

export const PLANNED_ACTIVITY_SIGN_OFF_PERIOD_STATUS: any = {
  [PlannedActivitySignOffPeriodStatus.AdminSigned]: 'adminsigned',
  [PlannedActivitySignOffPeriodStatus.Completed]: 'completed',
  [PlannedActivitySignOffPeriodStatus.Rejected]: 'rejected',
  [PlannedActivitySignOffPeriodStatus.NotSigned]: 'notsigned',
  [PlannedActivitySignOffPeriodStatus.Reopened]: 'reopened',
  [PlannedActivitySignOffPeriodStatus.Outdated]: 'outdated',
  [PlannedActivitySignOffPeriodStatus.Closed]: 'closed',
};
